<template>
    <Layout>
        <PageHeader :title="title" :items="items" :backButton="true" :prevRoutePath="backUrl" />
           <div class="row">
                <div class="col-lg-12 col-sm-12 mb-3">
                    <div class="card p-4">
                        <div class="media">
                            <div class="avatar-sm mr-3">
                                <span class="avatar-title rounded-circle bg-light text-primary border-primary font-size-22">
                                    <i class="bx bx-user-plus bx-md"></i>
                                </span>
                            </div>
                            <div class="media-body">
                                <h5 class="mt-3">{{ $t('instagram.add-new') }}</h5>
                            </div>
                        </div>
                        <div class="row mt-5">
                            <div class="col-sm-8">
                                <h5 v-if="result && !loading">{{ $t('instagram.total-results') }}: {{totalResult}} </h5>
                            </div>
                            <div class="col-sm-4 text-right">
                                <div class="input-group">
                                    <input
                                    id="search"
                                    type="text"
                                    class="form-control"
                                    v-model="searchKey"
                                    :placeholder="$t('all.searchh')"
                                    aria-describedby="search"
                                    @keyup.enter="searchIntagram2"
                                    />
                                    <div class="input-group-prepend">
                                    <button
                                        id="search"
                                        class="input-group-text bg-primary text-white"
                                        @click="searchIntagram2"
                                    >
                                        <i class="bx bx-search-alt search-icon"></i>
                                    </button>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="row mt-4 mb-4">
                            <div class="col-sm-12 p-5 m-5 text-center" v-if="!search && searchResult == 0 && error == ''">
                            ..
                            </div>
                            <div class="col-sm-12 p-5 m-5" v-if="loading">
                              <div class="text-center loading">
                                <b-spinner label="Loading..."></b-spinner><br> Loading..
                              </div>
                            </div>
                            <div v-if="error !== '' && !loading" class="row mt-5 mb-5 p-5 mx-auto">
                                <div class="text-center">
                                  <span class="text-danger">{{error}}</span>  
                                </div>
                            </div>
                              <div class="col-sm-12" v-if="!loading && dnf && !searchResult[0]">
                              <div class="text-center loading">
                                {{$t('all.dnf')}}
                              </div>
                            </div>
                            <div class="col-sm-12" v-if="!search || searchResult !== 0 || searchResultOsint !== 0">
                                <div class="row" v-if="searchResult[0]">
                                    <div class="col-sm-4 col-md-4 mb-3" v-for="(result, index) in searchResult" :key="index">
                                        <div class="card p-3 border">
                                            <div class="row text-Secondary">
                                            <div class="col-sm-8">
                                                <div class="media mb-3">
                                                <div class="avatar-md mr-2">
                                                    <img
                                                    src="https://img.icons8.com/ios/240/000000/user-male-circle.png"
                                                    class="mr-3 rounded-circle avatar-md"
                                                    alt="user-pic"
                                                    />
                                                </div>
                                                <div class="media-body">
                                                
                                                </div>
                                                </div>
                                            </div>
                                            <div class="col-sm-4 text-right">
                                                <router-link to="#">
                                                    <b-button class="btn btn-sm" variant="primary" @click="addInstagram(result.user.username)">
                                                    {{ $t('instagram.add') }} </b-button>
                                                </router-link>
                                            </div>
                                            <div class="col-sm-12 mb-2">
                                                <h5 class="mt-3">{{result.user.full_name}}<i class="bx bx-check-circle p-2 text-primary" v-if="result.user.is_verified"></i></h5>
                                                    <p class="text-secondary">
                                                    (<span class="mb-1">@{{result.user.username}} </span>)  <span v-if="result.user.is_private == 1" class="text-secondary"> <i class="text-dark mdi mdi-shield-lock-outline mdi-24px"></i> </span>
                                                    </p>
                                            </div>
                                        
                                            <div class="col-sm-12 text-center">
                                                <hr />
                                                <a :href="'https://www.instagram.com/'+result.user.username" target="_blank"
                                                rel="noopener noreferrer"
                                                ><b>{{ $t('instagram.see-profile') }}</b></a
                                                >
                                            </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div class="row" v-if="searchResultOsint[0]">
                                    <div class="col-sm-4 col-md-4 mb-3" v-for="(result, index) in searchResultOsint[0]" :key="index">
                                        <div class="card p-3 border">
                                            <div class="row text-Secondary">
                                            <div class="col-sm-8">
                                                <div class="media mb-3">
                                                <div class="avatar-md mr-2">
                                                    <img
                                                    src="https://img.icons8.com/ios/240/000000/user-male-circle.png"
                                                    class="mr-3 rounded-circle avatar-md"
                                                    alt="user-pic"
                                                    />
                                                </div>
                                                <div class="media-body">
                                                
                                                </div>
                                                </div>
                                            </div>
                                            <div class="col-sm-4 text-right">
                                                <router-link to="#">
                                                    <b-button class="btn btn-sm" variant="primary" @click="addInstagram(result.screen_name)">
                                                    {{ $t('instagram.add') }} </b-button>
                                                </router-link>
                                            </div>
                                            <div class="col-sm-12 mb-2">
                                                <h5 class="mt-3">{{result.full_name}}<i class="my-auto ml-1 text-primary mdi mdi-check-decagram mdi-18px" v-if="result.verified"></i></h5>
                                                    <p class="text-secondary">
                                                    (<span class="mb-1">@{{result.screen_name}} </span>)  <span v-if="result.private == 1" class="text-secondary"> <i class="text-dark mdi mdi-shield-lock-outline mdi-24px"></i> </span>
                                                    </p>
                                            </div>
                                  
                                            <div class="col-sm-12 text-center">
                                                <hr />
                                                <a :href="'https://www.instagram.com/'+result.screen_name" target="_blank"
                                                rel="noopener noreferrer"
                                                ><b>{{ $t('instagram.see-profile') }}</b></a
                                                >
                                            </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>     
                    </div>
                </div>
            </div>
    </Layout>
</template>

<script>
import InstaService from "@/helpers/osintgram.service.js";
import Layout from "../../../layouts/main";
import PageHeader from "@/components/page-header";
import appConfig from "@/app.config";
import axios from 'axios';
import moment from 'moment';
import Particle from "./particle.vue";
import SocmedService from "@/helpers/socmed.service";
import Swal from "sweetalert2";
import PreferenceService from "@/helpers/preference.service.js";

export default {
    page: {
        title: "Tools Twitter",
        meta: [{ name: "description", content: appConfig.description }],
    },
    components: { Layout, PageHeader, Particle },
    data() {
        return {
        avatar: process.env.VUE_APP_BASE_API_URL_OSINT+'stream-profil/?name=',
        pref_userinfo: {
            api_host:"",
            x_rapidapi_host:"",
            x_rapidapi_key:"",
        },
        pref_userinfo2: {
            api_host:"",
            x_rapidapi_host:"",
            x_rapidapi_key:"",
        },
        pref_search: {
            api_host:"",
            x_rapidapi_host:"",
            x_rapidapi_key:"",
        },
        pref_search2: {
            api_host:"",
            x_rapidapi_host:"",
            x_rapidapi_key:"",
        },
        pref_avatar: {
            api_host:"",
            x_rapidapi_host:"",
            x_rapidapi_key:"",
        },
        avatar_instagram:'https://img.icons8.com/ios/240/000000/user-male-circle.png',
        backUrl: "/instagram",
        loading: false,
        search: false,
        result:false,
        totalResult:"",
        error:"",
        dnf:false,
        searchKey: "",
        loadingInfo: false,
        searchResult: [],
        searchResultOsint:[],
        tableData:[],
        selected: [],
        selectAll: false,
        search:false,
        title: "Instagram",
        }
    },
    computed: {
        rows() {
        return this.tableData.length;
        },
    },
    methods: {
      getPreferencesSearch() {
            let id = 10;
            PreferenceService.getRapidApiByID(id)
            .then((response) => {
              // console.log(response.data.data);
                // this.pref = response.data.data;
                this.pref_search.api_host = response.data.data.api_host;
                this.pref_search.x_rapidapi_host = response.data.data.api_header_host;
                this.pref_search.x_rapidapi_key = response.data.data.api_header_key;
            })
            .catch((err) => {
                console.log(err);
            });
      },

      getPreferencesSearch2() {
          let id = 11;
          PreferenceService.getRapidApiByID(id)
          .then((response) => {
            // console.log(response.data.data);
              // this.pref_search = response.data.data;
              this.pref_search2.api_host = response.data.data.api_host;
              this.pref_search2.x_rapidapi_host = response.data.data.api_header_host;
              this.pref_search2.x_rapidapi_key = response.data.data.api_header_key;
          })
          .catch((err) => {
              console.log(err);
          });
      },

      getPreferencesAvatar() {
          let id = 62;
          PreferenceService.getRapidApiByID(id)
          .then((response) => {
            console.log('avatar', response.data.data);
              // this.pref_search = response.data.data;
              this.pref_avatar.api_host = response.data.data.api_host;
              this.pref_avatar.x_rapidapi_host = response.data.data.api_header_host;
              this.pref_avatar.x_rapidapi_key = response.data.data.api_header_key;
          })
          .catch((err) => {
              console.log(err);
          });
      },

      getPreferencesUserInfo() {
          let id = 13;
          PreferenceService.getRapidApiByID(id)
          .then((response) => {
            // console.log(response.data.data);
              // this.pref_userinfo = response.data.data;
              this.pref_userinfo.api_host = response.data.data.api_host;
              this.pref_userinfo.x_rapidapi_host = response.data.data.api_header_host;
              this.pref_userinfo.x_rapidapi_key = response.data.data.api_header_key;
          })
          .catch((err) => {
              console.log(err);
          });
      },

      getPreferencesUserInfo2() {
          let id = 14;
          PreferenceService.getRapidApiByID(id)
          .then((response) => {
            // console.log(response.data.data);
              // this.pref_userinfo = response.data.data;
              this.pref_userinfo2.api_host = response.data.data.api_host;
              this.pref_userinfo2.x_rapidapi_host = response.data.data.api_header_host;
              this.pref_userinfo2.x_rapidapi_key = response.data.data.api_header_key;
          })
          .catch((err) => {
              console.log(err);
          });
      },

      searchIntagram() {
          this.error = "";
          this.result = false;
          this.dnf = false;
          let searchData =  this.removeSpace(this.searchKey);
          if (this.searchKey != "") {
              this.search = true;    
              this.loading = true;
              this.searchResult = [];
              this.searchResultOsint = [];
              let headers = {
                      'content-type': 'application/json',
                      'x-rapidapi-host': this.pref_search.x_rapidapi_host,
                      'x-rapidapi-key': this.pref_search.x_rapidapi_key
                  };

              return axios.get(this.pref_search.api_host+'?user='+searchData, { headers: headers })
                .then((response) => {
                    this.searchResult = response.data.users;
                    // console.log(response.data.users);
                    // let total = response.data.pagination['total'];
                    this.totalResult = this.searchResult.length;
          
                    this.loading = false;  
                    this.result = true; 
                })
              .catch((err) => {
                  console.log(err);
                  this.searchIntagram2();
              });
          }
      },

      searchIntagram2() {
        this.error = "";
        this.result = false;
        this.dnf = false;
        let searchData =  this.removeSpace(this.searchKey);
        if (this.searchKey != "") {
            this.search = true;    
            this.loading = true;
            this.searchResult = [];
            this.searchResultOsint = [];
            let headers = {
                    'content-type': 'application/json',
                    'x-rapidapi-host': this.pref_search2.x_rapidapi_host,
                    'x-rapidapi-key': this.pref_search2.x_rapidapi_key
                };
            // console.log(headers);
            return axios.get(this.pref_search2.api_host+'?user='+searchData, { headers: headers })
              .then((response) => {
                  this.searchResult = response.data.users;
                  // console.log(response.data.users);
                  // let total = response.data.pagination['total'];
                  this.totalResult = this.searchResult.length;
        
                  this.loading = false;  
                  this.result = true; 
              })
            .catch((err) => {
                console.log(err);
                this.searchIntagramOsint();
                // if( err.response.status == 500 ){
                //     this.error = "Internal server Error";
                //     this.searchIntagramOsint();
                //   } else if( err.response.status == 404 ){
                //     this.error = "Server Not Found"; 
                //     this.searchIntagramOsint();
                //   } else if( err.response.status == 403 ){
                //     this.error = "Forbidden";
                //     this.searchIntagramOsint();
                //   } else if( err.response.status == 504 ){
                //     this.error = "Timeout";
                //     this.searchIntagramOsint();
                //   } else {
                //     this.searchIntagramOsint();
                //   }
            });
        }
      },
       
      searchIntagramOsint() {
        this.error = "";
        this.result = false;
        this.dnf = false;
        const data = {
            'nama': this.searchKey,
        };
        if (this.searchKey != "") {
            this.search = true;    
            this.loading = true;
            this.searchResultOsint = [];
            this.searchResult = [];
            InstaService.search(data)
            .then((response) => {
                this.searchResultOsint.push(response.data.output)
                this.totalResult = response.data.output.length
                let total = response.data.output.length;
                if(total == 0){
                  this.dnf = true;
                }
                this.loading = false;  
                this.result = true;
            })
            .catch((err) => {
                console.log(err);
                 if( err.response.status == 500 ){
                    this.error = this.$t('all.error-500');
                  } else if( err.response.status == 404 ){
                    this.error = this.$t('all.error-404');
                  }
                this.search = false;
                this.loading = false;  
            });
        }
      },

      select() {
      // console.log('selected');
          this.selected = [];
          if (!this.selectAll) {
              for (let i in this.tableData) {
                  this.selected.push(this.tableData[i].id_instagram);
              }
          }
      },

      listInstagram(){
          this.loadingInfo = true,
          SocmedService.getAllInstagram()
          .then(response => {
                    this.tableData = []
                    this.totalAccount = response.data.data.length;
                    response.data.data.forEach(val => {
                        const data = {    
                        "id_instagram" : val.id_instagram,
                        "user_id" : val.user_id,
                        "account" : val.account,
                        "full_name" : val.full_name,
                        "verified" : val.is_verified,
                        "picture" : val.picture,
                        "picture_hd" : val.picture_hd,
                        "followers" : val.followers,
                        "following" : val.following,
                        "media" : val.media,
                        "created_at" : this.formatDate(val.created_at),
                        "updated_at" : this.formatDate(val.updated_at),
                        }
                        this.tableData.push(data);
                        this.loadingInfo = false;
                    });
                })
                .catch(err => {
                    console.log(err);
                    this.loadingInfo = false;
            });
      },

      addInstagram(username){
          var account = username;
          Swal.fire({
          title: this.$t('alert.alert-add')+username+' ?',
          showCancelButton: true,
          confirmButtonText: 'Save',
          confirmButtonColor: "#0067AC",
          }).then((result) => {
          if (result.isConfirmed) {  
          this.getAvatarInstagram(username); 
          this.loading = true;
          this.searchResult = [];
            var data ={
              "nama": username
            }
            InstaService.getUsername(data)
                .then( response => {
                var data_akun = response.data.output;
                this.saveInstagram(data_akun)
                // console.log(response.data.output)
              })
              .catch(err => {
              console.log(err);
              this.addInstagramRapid(account);
          });
          } 
          })
      },

      getAvatarInstagram(username) {
        // if (this.searchKey != "") {
            let headers = {
                    'content-type': 'application/json',
                    'x-rapidapi-host': this.pref_avatar.x_rapidapi_host,
                    'x-rapidapi-key': this.pref_avatar.x_rapidapi_key
                };
            // console.log(headers);
            return axios.get(this.pref_avatar.api_host+'?url=https://www.instagram.com/'+username+'/', { headers: headers })
              .then((response) => {
                // console.log('avatar', response.data.data.image);
                  this.avatar_instagram = response.data.data.image;
              })
            .catch((err) => {
                console.log(err);
                //   }
            });
        // }
      },
        
      addInstagramRapid(username){
          this.loading = true
          this.searchResult = []
                var user = username;
                let headers = {
                    'content-type': 'application/json',
                    'x-rapidapi-host': this.pref_userinfo.x_rapidapi_host,
                    'x-rapidapi-key': this.pref_userinfo.x_rapidapi_key
                };
                console.log(headers);
                return axios.get(this.pref_userinfo.api_host+'?username='+user, { headers: headers })
                .then( response => {
                var val = response.data;

                let data = {
                    "pk" : val.id,
                    "username" : val.username,
                    "full_name" : val.full_name,
                    "biography" : val.biography,
                    "following_count" : val.edge_follow.count,
                    "follower_count" : val.edge_followed_by.count,
                    "media_count" : val.edge_owner_to_timeline_media.count,
                    "is_private" : val.is_private,
                    "is_verified" : val.is_verified,
                    "is_business" : val.is_business_account,
                    "picture" : val.profile_pic_url,
                    "picture_hd" : val.profile_pic_url_hd,
                    "public_email" : val.business_email,
                    "contact_phone_number" : val.business_phone_number,
                    "bussiness_category_name" : val.business_category_name,
                    "category_name" : val.category_name,
                }
                this.saveInstagram(data)
              })
              .catch(err => {
              this.addInstagramRapid2(user)
              console.log(err);
          });
      },

      addInstagramRapid2(username){
          this.loading = true
          this.searchResult = []
                let user = username;
                let headers = {
                    'content-type': 'application/json',
                    'x-rapidapi-host': this.pref_userinfo2.x_rapidapi_host,
                    'x-rapidapi-key': this.pref_userinfo2.x_rapidapi_key
                };
                console.log(headers);
            return axios.get(this.pref_userinfo2.api_host+'?username='+user, { headers: headers })
                .then( response => {
                var val = response.data;
                let data = {
                    "pk" : val.id,
                    "username" : val.username,
                    "full_name" : val.full_name,
                    "biography" : val.biography,
                    "following_count" : val.edge_follow.count,
                    "follower_count" : val.edge_followed_by.count,
                    "media_count" : val.edge_owner_to_timeline_media.count,
                    "is_private" : val.is_private,
                    "is_verified" : val.is_verified,
                    "is_business" : val.is_business_account,
                    "picture" : val.profile_pic_url,
                    "picture_hd" : val.profile_pic_url_hd,
                    "public_email" : val.business_email,
                    "contact_phone_number" : val.business_phone_number,
                    "bussiness_category_name" : val.business_category_name,
                    "category_name" : val.category_name,
                }
                this.saveInstagram(data)
              })
              .catch(err => {
              this.loading = false;
              console.log(err);
          });
      },

      saveInstagram(data){
              // console.log(data);
              var today = new Date();
              var time = today.toLocaleString('en-US', { timeZone: 'Asia/Jakarta' });
              var data_ig = {
              "id_target" : '',
              "user_id" : data.pk,
              "account" : data.username,
              "full_name" : data.full_name,
              "bio" : data.biography,
              "following" : data.following_count,
              "followers" : data.follower_count,
              "media" : data.media_count,
              "is_private" : data.is_private,
              "is_verified" : data.is_verified,
              "is_business" : data.is_business,
              "picture" :  this.avatar_instagram,
              "picture_hd" : null,
              "public_email" : data.public_email,
              "contact_phone_number" : data.contact_phone_number,
              "bussiness_category_name" : data.business_category_name,
              "category_name" : data.category_name,
              "updated_at" : time
          };
          // console.log(data_ig);
            SocmedService.createInstagram(data_ig)
                  .then( response => {
                      if (response.status == 212) {    
                          Swal.fire('Instagram is Updated','', 'success');
                      } else {
                          Swal.fire(this.$t('alert.alert-save'), '', 'success') 
                      }    
                      this.loading = false
                      this.searchResult = "",
                      this.searchKey ="",
                      this.$router.push('/instagram');
                      this.search = false;
                      this.dnf = false;
                      this.searchResult = 0; 
                      this.result = false;   
              })
              .catch(err => {
              console.log(err);
          });
      },

      formatDate(value){
          return moment(value).format("dddd, YYYY-MM-DD hh:mm");
      },

      removeSpace(value){
        let str = value.replace(/\s/g, '');
        return str;
      }
  },
  mounted(){
    this.getPreferencesSearch();
    this.getPreferencesSearch2();
    this.getPreferencesUserInfo();
    this.getPreferencesUserInfo2();
    this.getPreferencesAvatar();
}
}
</script>

<style scoped>
.card {
    border: 2px solid #f1f1f1;
}
</style>
